import axios from 'axios';
import Cookies from 'js-cookie';

// Cria uma instância do Axios apontando para o nosso Backend
export const api = axios.create({
  baseURL: process.env.NEXT_PUBLIC_API_URL,
});

// Interceptador: Antes de qualquer requisição sair do Frontend, 
// ele pega o Token guardado no cookie e anexa no cabeçalho (Header).
api.interceptors.request.use((config) => {
  const token = Cookies.get('hmdocs_token');

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});
